"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataModel_1 = __importDefault(require("./DataModel"));
class Election extends DataModel_1.default {
    constructor(data) {
        super();
        this.type = data.type;
        this.time = data.time;
        this.proof = data.proof;
        this.members = data.members;
        this.height = data.height;
        this.hash = data.hash;
        this.delay = data.delay;
    }
    get data() {
        return this;
    }
}
exports.default = Election;
//# sourceMappingURL=Election.js.map